











import { Component, Mixins } from "vue-property-decorator";
import { MenuPane } from "../../panes";
import { ModelEditableMixin } from "../mixins";
import { EditCommandManageableMixin } from "./mixins";

@Component({
  components: {
    MenuPane,
  },
})
export default class EditCommandMenu extends Mixins(ModelEditableMixin, EditCommandManageableMixin) {
}
